import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Radio, LogOut, User } from "lucide-react";

export function TopNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const doLogout = () => {
    logout();
    nav("/login");
  };

  const active = (p) => loc.pathname === p;

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#E4E4E7]">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <Radio className="text-[#0090A8]" size={22} strokeWidth={2} />
          <span className="font-display font-black text-lg tracking-tight text-[#0A0A0A]">WEBINAR<span className="text-[#0090A8]">HUB</span></span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-4">
          <Link
            to="/"
            data-testid="nav-webinars"
            className={`text-sm font-medium px-3 py-1.5 transition-colors ${active("/") ? "text-[#0090A8]" : "text-gray-500 hover:text-[#0A0A0A]"}`}
          >
            Webinars
          </Link>
          <Link
            to="/profile"
            data-testid="nav-profile"
            className={`flex items-center gap-2 text-sm font-medium px-3 py-1.5 transition-colors ${active("/profile") ? "text-[#0090A8]" : "text-gray-500 hover:text-[#0A0A0A]"}`}
          >
            <User size={16} /> <span className="hidden sm:inline">{user?.name}</span>
          </Link>
          <button
            onClick={doLogout}
            data-testid="nav-logout"
            className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-[#D92D20] px-3 py-1.5 transition-colors"
          >
            <LogOut size={16} /> <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
